
import React from 'react';
import Button from '../../../components/base/Button';

const ProductsHero = () => {
  const handleContactClick = () => {
    window.open('tel:+21620403150', '_self');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://public.readdy.ai/ai/img_res/51204b2a89b3104065238cf9413a5d8c.jpg")`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Nos <span className="text-red-500">Produits</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            Découvrez notre gamme complète d'équipements de sécurité professionnels. 
            Caméras, systèmes d'alarme, détection incendie et contrôle d'accès.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              className="bg-red-600 text-white hover:bg-red-700 px-8 py-4 text-lg"
              onClick={handleContactClick}
            >
              <i className="ri-phone-line mr-2"></i>
              Contactez-nous
            </Button>
          </div>
        </div>
      </div>

      {/* Flèche de défilement */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};

export default ProductsHero;
